import AssignedTasksPanel from "@/components/equipo/AssignedTasksPanel";

/** Wrapper BNT Asistente — vista rápida (solo abiertas). */
export default function BntAsistenteMisTareasPanel(props) {
  return <AssignedTasksPanel variant="assistant" {...props} />;
}
